import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["io"],
  font: "16px arial",
  iconCategories,
  id: "trenord",
  industry: IndustryEnum.Transport,
  name: "Trenord",
  slug: "trenordit",
  ...colors,
};
export default config;
